function initSwiperProductGallery() {
  const galleryBox = document.querySelector(".product-custom-gallery");

  if (!galleryBox) {
    return;
  }

  const thumbs = galleryBox.querySelectorAll(
    ".product-custom-gallery__thumbs li"
  );
  const slider = galleryBox.querySelector(
    ".product-custom-gallery__slider .swiper"
  );

  const swiper = new Swiper(slider, {
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      init() {
        handleVideoPlayback(this);
      },
      slideChange() {
        changeActiveThumb(this);
        handleVideoPlayback(this);
      },
    },
  });

  function changeActiveThumb(swiper) {
    const activeIndex = +swiper.activeIndex;

    thumbs.forEach((item) => item.classList.remove("active"));
    thumbs.forEach((item) => {
      const itemIndex = +item.dataset.index;
      if (itemIndex === activeIndex) item.classList.add("active");
    });
  }

  function handleVideoPlayback(swiper) {
    const allVideos = swiper.el.querySelectorAll("video");

    allVideos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const videoInActiveSlide = activeSlide.querySelector("video");
    if (videoInActiveSlide) {
      if (videoInActiveSlide.readyState >= 3) {
        videoInActiveSlide.play().catch(() => {});
      } else {
        videoInActiveSlide.addEventListener(
          "canplay",
          () => {
            videoInActiveSlide.play().catch(() => {});
          },
          { once: true }
        );
      }
    }
  }

  thumbs.forEach((item) =>
    item.addEventListener("click", () => {
      if (item.classList.contains("active")) {
        return;
      }

      const itemIndex = +item.dataset.index;
      swiper.slideTo(itemIndex);
    })
  );
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiperProductGallery();
});
